var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    function isArray(val) {
      return toString.call(val) === "[object Array]";
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    function isArrayBuffer(val) {
      return toString.call(val) === "[object ArrayBuffer]";
    }
    function isFormData(val) {
      return typeof FormData !== "undefined" && val instanceof FormData;
    }
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }
      return result;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber(val) {
      return typeof val === "number";
    }
    function isObject(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject(val) {
      if (toString.call(val) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val) {
      return toString.call(val) === "[object Date]";
    }
    function isFile(val) {
      return toString.call(val) === "[object File]";
    }
    function isBlob(val) {
      return toString.call(val) === "[object Blob]";
    }
    function isFunction(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    function isURLSearchParams(val) {
      return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result;
    }
    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isObject,
      isPlainObject,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/enhanceError.js
var require_enhanceError = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/enhanceError.js"(exports, module) {
    "use strict";
    module.exports = function enhanceError(error, config, code, request, response) {
      error.config = config;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };
      return error;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/createError.js
var require_createError = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/createError.js"(exports, module) {
    "use strict";
    var enhanceError = require_enhanceError();
    module.exports = function createError(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config, code, request, response);
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var createError = require_createError();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError(
          "Request failed with status code " + response.status,
          response.config,
          null,
          response.request,
          response
        ));
      }
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      /* @__PURE__ */ function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path)) {
              cookie.push("path=" + path);
            }
            if (utils.isString(domain)) {
              cookie.push("domain=" + domain);
            }
            if (secure === true) {
              cookie.push("secure");
            }
            document.cookie = cookie.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove() {
          }
        };
      }()
    );
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url) {
          var href = url;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/Cancel.js
var require_Cancel = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/Cancel.js"(exports, module) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module.exports = Cancel;
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var createError = require_createError();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    module.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError("Request aborted", config, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError("Network Error", config, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || defaults.transitional;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(createError(
            timeoutErrorMessage,
            config,
            transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/defaults.js
var require_defaults = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/defaults.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var enhanceError = require_enhanceError();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults;
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new Cancel("canceled");
      }
    }
    module.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/env/data.js"(exports, module) {
    module.exports = {
      "version": "0.24.0"
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var VERSION = require_data().version;
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        }
        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i = keys.length;
      while (i-- > 0) {
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module.exports = {
      assertOptions,
      validators
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(config) {
      if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        config = config || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios.prototype[method] = function(url, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data
        }));
      };
    });
    module.exports = Axios;
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var Cancel = require_Cancel();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i;
        var l = token._listeners.length;
        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    module.exports = function isAxiosError(payload) {
      return typeof payload === "object" && payload.isAxiosError === true;
    };
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios2 = createInstance(defaults);
    axios2.Axios = Axios;
    axios2.Cancel = require_Cancel();
    axios2.CancelToken = require_CancelToken();
    axios2.isCancel = require_isCancel();
    axios2.VERSION = require_data().version;
    axios2.all = function all(promises) {
      return Promise.all(promises);
    };
    axios2.spread = require_spread();
    axios2.isAxiosError = require_isAxiosError();
    module.exports = axios2;
    module.exports.default = axios2;
  }
});

// node_modules/.pnpm/axios@0.24.0/node_modules/axios/index.js
var require_axios2 = __commonJS({
  "node_modules/.pnpm/axios@0.24.0/node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios();
  }
});

// src/utils/body-lock.js
var bodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.add("js-scroll-lock");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.remove("js-scroll-lock");
  }
};
var body_lock_default = new bodyLock();

// src/utils/meta-theme.js
var metaThemeColorElement = document.querySelector("meta[name=theme-color]");
var MetaThemeColor = class {
  /**
   * Set modal color as the theme color.
   */
  setModalColor() {
    const themeColor = "#fff";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set modal color as the theme color.
   */
  setAnnouncementBarColor() {
    const themeColor = "#242424";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set default color as the theme color.
   */
  setDefaultColor() {
    const announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
    const color = "#fff";
    if (announcementBarElement.classList.contains("js-window-scrolled")) {
      metaThemeColorElement.setAttribute("content", color);
    } else {
      this.setAnnouncementBarColor();
    }
  }
  /**
   * Set custom color as theme color.
   * 
   * @param {string} color 
   */
  setCustomColor(color) {
    metaThemeColorElement.setAttribute("content", color);
  }
};
var meta_theme_default = new MetaThemeColor();

// src/utils/debounce.js
var debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(void 0, args);
    }, timeout);
  };
};

// src/extenders/surf-modal.js
var _hideOnClickOutside, hideOnClickOutside_fn, _addCloseEventListener, addCloseEventListener_fn, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn;
var SurfModal = class {
  constructor() {
    __privateAdd(this, _hideOnClickOutside);
    /**
     * Add close event listener
     */
    __privateAdd(this, _addCloseEventListener);
    /**
     * Get correct modal by target id
     *
     * @param {string} ariaControls
     *
     * @returns {element}
     */
    __privateAdd(this, _getCorrectModalByAriaControls);
    /**
     * Send variant image update event.
     */
    __publicField(this, "sendUpdateModalState", debounce((state, ariaControls, triggerElement, deeplinkTarget) => {
      const event = new CustomEvent("modal-state", {
        detail: {
          state,
          ariaControls: `${ariaControls}`,
          deeplinkTarget: `${deeplinkTarget || null}`,
          element: triggerElement ? triggerElement : null
        }
      });
      document.dispatchEvent(event);
    }, 100));
  }
  /**
   * Open modal.
   * 
   * @param {string} ariaControls 
   * @param {HTMLElement} triggerElement 
   * @param {string} deeplinkTarget optional
   */
  openModal(ariaControls, triggerElement, deeplinkTarget) {
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControls}"]`);
    if (modal) {
      const allActiveItemsInsideModal = modal.querySelectorAll(".js-active");
      modal.classList.remove("initial-load");
      modal.classList.add("js-modal-open");
      if (ariaControls == "cart-drawer") {
        const metaThemeColorElement2 = document.querySelector("meta[name=theme-color]");
        const announcementBarElement = document.querySelector(".announcement-bar");
        const announcementBarHeight = announcementBarElement.offsetHeight;
        const offset = announcementBarHeight * 3;
        const scrollPosition = window.scrollY;
        if (scrollPosition > offset) {
          const themeColor = "#FFFFFF";
          metaThemeColorElement2.setAttribute("content", themeColor);
        } else {
          const themeColor = "#FFFFFF";
          metaThemeColorElement2.setAttribute("content", themeColor);
        }
      }
      if (allActiveItemsInsideModal.length > 0) {
        allActiveItemsInsideModal.forEach((activeItemElement) => {
          activeItemElement.classList.remove("js-active");
        });
      }
      if (deeplinkTarget) {
        const deeplinkTargetElement = modal.querySelector(`#${deeplinkTarget}`);
        if (deeplinkTargetElement) {
          deeplinkTargetElement.classList.add("js-active");
        }
      }
      __privateMethod(this, _addCloseEventListener, addCloseEventListener_fn).call(this, modal, ariaControls);
      __privateMethod(this, _hideOnClickOutside, hideOnClickOutside_fn).call(this, modal, ariaControls);
      body_lock_default.lock();
      this.sendUpdateModalState("open", ariaControls, triggerElement, deeplinkTarget);
    }
    allSameAriaControlsElements.forEach((ariaElement) => {
      ariaElement.ariaExpanded = "true";
    });
  }
  /**
   * Close modal 
   * @param {string} ariaControls 
   */
  closeModal(ariaControls) {
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControls}"]`);
    if (modal) {
      modal.classList.remove("js-modal-open");
      body_lock_default.unlock();
      this.sendUpdateModalState("close", ariaControls);
    }
    allSameAriaControlsElements == null ? void 0 : allSameAriaControlsElements.forEach((ariaElement) => {
      ariaElement.ariaExpanded = "false";
    });
  }
  /**
   * Open modal.
   * 
   * @param {string} ariaControls 
   * @param {HTMLElement} triggerElement 
   * @param {string} deeplinkTarget optional
   */
  handleModalState(ariaControls, triggerElement, deeplinkTarget) {
    const ariaExpanded = triggerElement.getAttribute("aria-expanded");
    const metaThemeColorElement2 = document.querySelector("meta[name=theme-color]");
    if (ariaExpanded === "false") {
      meta_theme_default.setModalColor();
      if (ariaControls.includes("reviews-modal")) {
        metaThemeColorElement2.setAttribute("content", "#000000E5");
      }
      this.openModal(ariaControls, triggerElement, deeplinkTarget);
      const chevronIconElement = triggerElement.querySelector(".icon-chevron");
      if (chevronIconElement) {
        chevronIconElement.classList.add("js-open");
        chevronIconElement.classList.remove("js-closed");
      }
    } else {
      meta_theme_default.setDefaultColor();
      this.closeModal(ariaControls);
      const chevronIconElement = triggerElement.querySelector(".icon-chevron");
      if (chevronIconElement) {
        chevronIconElement.classList.remove("js-open");
        chevronIconElement.classList.add("js-closed");
      }
    }
  }
  /**
   * Get current state of the cart modal.
   *
   * @returns {{state: string, isCartOpen: boolean}}
   */
  getCurrentState(ariaControls) {
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    if (modal.classList.contains("js-modal-open")) {
      return {
        state: "open",
        isModalOpen: true
      };
    } else {
      return {
        state: "closed",
        isModalOpen: false
      };
    }
  }
};
_hideOnClickOutside = new WeakSet();
hideOnClickOutside_fn = function(modal, ariaControls) {
  const outsideClickListener = (event) => {
    var _a;
    const target = event.target;
    const allModalOpeners = document.querySelectorAll(".js-handle-modal");
    const arrayAllModalOpeners = [...allModalOpeners];
    const ariaControlValue = target.getAttribute("aria-labelledby");
    const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControls}"]`);
    if (target.classList.contains("modal-overlay")) {
      this.closeModal(ariaControls);
      removeClickListener();
      allSameAriaControlsElements.forEach((ariaElement) => {
        const chevronIconElement = ariaElement.querySelector(".icon-chevron");
        if (chevronIconElement) {
          chevronIconElement.classList.remove("js-open");
          chevronIconElement.classList.add("js-closed");
        }
        ariaElement.ariaExpanded = "false";
      });
    } else {
      if (target !== modal && target.closest(".modal") || ((_a = target.closest(".button")) == null ? void 0 : _a.classList.contains("js-no-close")) || arrayAllModalOpeners.filter(
        (modalOpener) => modalOpener === target.closest(".js-handle-modal")
      ).length !== 0) {
      } else {
        this.closeModal(ariaControls);
        removeClickListener();
        allSameAriaControlsElements.forEach((ariaElement) => {
          const chevronIconElement = ariaElement.querySelector(".icon-chevron");
          if (chevronIconElement) {
            chevronIconElement.classList.remove("js-open");
            chevronIconElement.classList.add("js-closed");
          }
          ariaElement.ariaExpanded = "false";
        });
      }
    }
  };
  const removeClickListener = () => {
    document.removeEventListener("click", outsideClickListener);
  };
  document.addEventListener("click", outsideClickListener);
};
_addCloseEventListener = new WeakSet();
addCloseEventListener_fn = function(modal, ariaControls) {
  const allCloseModalButtons = modal.querySelectorAll(".js-close-modal");
  const submitButton = modal.querySelector(".js-modal-submit");
  if (allCloseModalButtons) {
    allCloseModalButtons.forEach((closeModalButton2) => {
      const closeClick = () => {
        this.closeModal(ariaControls);
        removeClickListener();
      };
      const removeClickListener = () => {
        closeModalButton2.removeEventListener("click", closeClick);
      };
      closeModalButton2.addEventListener("click", () => {
        this.handleModalState(ariaControls, closeModalButton2);
      });
    });
  }
  if (submitButton) {
    const closeClick = () => {
      this.closeModal(ariaControls);
      removeClickListener();
    };
    const removeClickListener = () => {
      closeModalButton.removeEventListener("click", closeClick);
    };
    submitButton.addEventListener("click", closeClick);
  }
};
_getCorrectModalByAriaControls = new WeakSet();
getCorrectModalByAriaControls_fn = function(ariaControls) {
  const modalChild = document.querySelector(`[aria-labelledby="${ariaControls}"]`);
  const modalElement = modalChild ? modalChild.closest(".modal") : null;
  if (modalElement)
    return modalElement;
};
var surf_modal_default = SurfModal;

// src/utils/add-button-state.js
var addButton = class {
  /**
   * set add button to available.
   */
  setActive(productFormElement) {
    const submitElement = productFormElement.querySelectorAll(".js-add-to-bag");
    submitElement.forEach((addToBagButtonElement) => {
      const textElement = addToBagButtonElement == null ? void 0 : addToBagButtonElement.querySelector(".button__text");
      addToBagButtonElement.disabled = false;
      if (textElement) {
        textElement.innerHTML = `
          ${window.translations.add_to_cart}
        `;
      }
    });
  }
  /**
   * Set add to cart button to disabled.
   * @param {HTMLElement} productFormElement 
   */
  setDisabled(productFormElement) {
    const submitElement = productFormElement.querySelectorAll(".js-add-to-bag");
    submitElement.forEach((addToBagButtonElement) => {
      const textElement = addToBagButtonElement == null ? void 0 : addToBagButtonElement.querySelector(".button__text");
      addToBagButtonElement.disabled = true;
      if (textElement) {
        if (addToBagButtonElement.dataset.comingSoon === "true") {
          textElement.innerHTML = `
          ${window.translations.coming_soon}
        `;
        } else {
          textElement.innerHTML = `
          ${window.translations.sold_out}
        `;
        }
      }
    });
  }
};
var add_button_state_default = new addButton();

// node_modules/.pnpm/@shopify+theme-currency@4.1.1/node_modules/@shopify/theme-currency/currency.js
var moneyFormat = "${{amount}}";
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

// src/utils/product-utils.js
var sendVariantOptionsChanged = (productFormElement, clickedElement = null) => {
  const event = new CustomEvent("variantOptionsChanged", {
    detail: {
      productFormElement,
      clickedElement
    }
  });
  document.dispatchEvent(event);
};
var handleFormInputs = (productFormElement, form) => {
  const parentVariantsElement = form.querySelector(".product-variants");
  if (!parentVariantsElement)
    return () => {
    };
  const allFieldsetElements = parentVariantsElement.querySelectorAll("fieldset");
  const handleFieldsetChange = (event) => {
    const clickedInput = event.target;
    const clickedContainer = clickedInput.closest(".input--square");
    if (clickedContainer) {
      clickedContainer.classList.add("js-variant-loading");
    }
    sendVariantOptionsChanged(productFormElement, clickedContainer);
  };
  allFieldsetElements.forEach((fieldsetElement) => {
    fieldsetElement.addEventListener("change", handleFieldsetChange);
  });
  return () => {
    allFieldsetElements.forEach((fieldsetElement) => {
      fieldsetElement.removeEventListener("change", handleFieldsetChange);
    });
  };
};
var handleVariantAfterInputChange = (productFormElement) => {
  const allVariantElements = productFormElement.querySelectorAll(".variant");
  let correctVariant = getCorrectVariantFromOptions(productFormElement, allVariantElements);
  if (!correctVariant) {
    const variantObject = getSelectedVariant(productFormElement);
    correctVariant = variantObject;
  }
  if (correctVariant) {
    setSelectedSizeBodyHeight(productFormElement, correctVariant);
    if (correctVariant && isVariantAvailable(correctVariant) === true) {
      const variantId = correctVariant.id;
      setVariantImage(correctVariant);
      setVariantId(productFormElement, variantId);
      setInputelementsActiveToVariant(productFormElement, correctVariant);
      setPrice(productFormElement, correctVariant);
      setStockStatus(productFormElement, correctVariant);
      setVariantTitleInWishlistModal(correctVariant);
      add_button_state_default.setActive(productFormElement);
    } else {
      setVariantImage(correctVariant);
      setVariantId(productFormElement, correctVariant.id);
      setVariantTitleInWishlistModal(correctVariant);
      setStockStatus(productFormElement, correctVariant);
      setVariantSizeInNotifyMeModal(correctVariant);
      openNotifyMeModal();
      add_button_state_default.setDisabled(productFormElement);
    }
  } else {
    setSelectedSizeBodyHeight(productFormElement);
  }
  setNotAvailableSizeOptionsToDisabled(productFormElement);
};
var openNotifyMeModal = () => {
  const backInStockModal = new surf_modal_default();
  const backInStockModalOpenerElement = document.querySelector('.js-handle-modal[aria-controls="notify-me-modal"]');
  const backInStockModalElement = document.querySelector("notify-me-modal");
  const allFormOverlayElement = backInStockModalElement.querySelectorAll(".form-overlay");
  allFormOverlayElement.forEach((formOverlayElement) => {
    formOverlayElement.classList.remove("js-active");
  });
  backInStockModal.openModal("notify-me-modal", backInStockModalOpenerElement);
};
var setVariantTitleInWishlistModal = (correctVariant) => {
  const variantTitleElement = document.querySelector(".js-variant-title");
  if (variantTitleElement) {
    variantTitleElement.innerHTML = correctVariant.title;
  }
};
var setVariantSizeInNotifyMeModal = (correctVariant) => {
  const variantTitleElement = document.querySelector("notify-me-modal .js-selected-size");
  let variantTitle = correctVariant.title;
  if (correctVariant.title.includes(" / ")) {
    variantTitle = correctVariant.title.split(" / ")[1];
  }
  if (variantTitleElement) {
    variantTitleElement.innerHTML = variantTitle;
  }
};
var listenForVariantOptionsChanges = (callbackFunction) => {
  document.addEventListener("variantOptionsChanged", callbackFunction);
};
listenForVariantOptionsChanges((event) => {
  const productFormElement = event.detail.productFormElement;
  handleVariantAfterInputChange(productFormElement);
  setTimeout(() => {
    const allVariantInputs = productFormElement.querySelectorAll(".input--square");
    allVariantInputs.forEach((input) => {
      input.classList.remove("js-variant-loading");
    });
  }, 100);
});
var getAllVariants = (productFormElement) => {
  const variantsDataElement = productFormElement.querySelector(".variants-data");
  const allVariants = variantsDataElement ? JSON.parse(variantsDataElement.innerHTML).variants : null;
  return allVariants || null;
};
var setNotAvailableSizeOptionsToDisabled = (productFormElement) => {
  const colorVariantFieldsetElement = productFormElement.querySelector("fieldset.variant--color");
  const selectedColor = colorVariantFieldsetElement ? getValueFromVariantSelector(colorVariantFieldsetElement, "color") : null;
  const sizeVariantFieldsetElement = productFormElement.querySelector("fieldset.variant--size");
  const allInputElementsOfVariantSizeFieldset = sizeVariantFieldsetElement == null ? void 0 : sizeVariantFieldsetElement.querySelectorAll('input[type="radio"]');
  const allVariants = getAllVariants(productFormElement);
  const stockStatusContainer = document.querySelector(".stock-status-container");
  const lowStockThreshold = stockStatusContainer ? parseInt(stockStatusContainer.dataset.lowStock) : 5;
  const variantsDataElement = productFormElement.querySelector(".variants-data");
  const showLowStockDot = (variantsDataElement == null ? void 0 : variantsDataElement.dataset.showLowStockDot) === "true";
  allInputElementsOfVariantSizeFieldset == null ? void 0 : allInputElementsOfVariantSizeFieldset.forEach((sizeInputElement) => {
    const sizeValue = sizeInputElement.value;
    const selectedOptions = selectedColor + " || " + sizeValue;
    const correctVariantObject = allVariants.find((element) => element.options === selectedOptions) || null;
    const inputParentElement = sizeInputElement.closest(".input");
    const label = inputParentElement.querySelector("label");
    if (correctVariantObject == null ? void 0 : correctVariantObject.available) {
      inputParentElement.classList.remove("js-out-of-stock");
      const inventory = correctVariantObject.inventory_quantity;
      const existingIndicator = label == null ? void 0 : label.querySelector(".low-stock-indicator");
      if (existingIndicator) {
        existingIndicator.remove();
      }
      if (inventory > 0 && inventory <= lowStockThreshold && showLowStockDot) {
        inputParentElement.classList.add("js-low-stock");
        if (label) {
          const indicator = document.createElement("span");
          indicator.className = "low-stock-indicator";
          indicator.innerHTML = '<span class="low-stock-indicator__dot"></span>';
          label.appendChild(indicator);
        }
      } else {
        inputParentElement.classList.remove("js-low-stock");
      }
    } else {
      inputParentElement.classList.add("js-out-of-stock");
      inputParentElement.classList.remove("js-low-stock");
      const existingIndicator = label == null ? void 0 : label.querySelector(".low-stock-indicator");
      if (existingIndicator) {
        existingIndicator.remove();
      }
    }
  });
};
var setFirstAvialableVariantActive = (productFormElement) => {
  const allVariants = getAllVariants(productFormElement);
  if (!allVariants)
    return;
  if (window.location.hash.includes("size")) {
    const sizeFromUrl = window.location.hash.split("size=")[1];
    const colorVariantFieldsetElement = productFormElement.querySelector("fieldset.variant--color");
    const selectedColor = getValueFromVariantSelector(colorVariantFieldsetElement, "color");
    const selectedOptions = selectedColor ? `${selectedColor} || ${sizeFromUrl.toUpperCase()}` : sizeFromUrl;
    const correctVariant = (allVariants == null ? void 0 : allVariants.find((element) => element.options === selectedOptions)) || null;
    if (correctVariant) {
      const variantId = correctVariant.id;
      setVariantImage(correctVariant);
      setVariantId(productFormElement, variantId);
      setInputelementsActiveToVariant(productFormElement, correctVariant);
      setStockStatus(productFormElement, correctVariant);
      setSelectedSizeBodyHeight(productFormElement, correctVariant);
      setNotAvailableSizeOptionsToDisabled(productFormElement);
    }
  } else {
    const allAvailableVariants = allVariants.map((variantObject) => {
      if (isVariantAvailable(variantObject)) {
        return variantObject;
      }
    });
    const filteredAllAvailableVariants = allAvailableVariants.filter((variantObject) => variantObject);
    if (filteredAllAvailableVariants.length > 0) {
      const variantId = filteredAllAvailableVariants[0].id;
      const correctVariant = getVariantFromId(productFormElement, variantId);
      setVariantImage(correctVariant);
      setVariantId(productFormElement, variantId);
      setInputelementsActiveToVariant(productFormElement, filteredAllAvailableVariants[0]);
      setStockStatus(productFormElement, filteredAllAvailableVariants[0]);
      setSelectedSizeBodyHeight(productFormElement, filteredAllAvailableVariants[0]);
      add_button_state_default.setActive(productFormElement);
    } else {
      const variantsDataElement = productFormElement.querySelector(".variants-data");
      const productInfo = variantsDataElement ? JSON.parse(variantsDataElement.innerHTML).product : null;
      const hasStoreInventory = allVariants.some((variant) => (variant.inventory_in_store || 0) > 0);
      if (productInfo) {
        if (productInfo.coming_soon === "true") {
          add_button_state_default.setComingSoon();
        }
      } else if (hasStoreInventory) {
        const firstVariant = allVariants[0];
        setStockStatus(productFormElement, firstVariant);
        add_button_state_default.setDisabled(productFormElement, firstVariant.inventory_in_store || 0);
      } else {
        add_button_state_default.setDisabled(productFormElement);
        openNotifyMeModal();
      }
    }
  }
};
var setInputelementsActiveToVariant = (productFormElement, variantObject) => {
  var _a, _b;
  const allActiveOptions = (_a = variantObject.options) == null ? void 0 : _a.split(" || ");
  const allActiveOptionTitles = (_b = variantObject.option_titles) == null ? void 0 : _b.split(" || ");
  allActiveOptions == null ? void 0 : allActiveOptions.map((activeOptionString, index) => {
    const activeOptionElement = productFormElement.querySelector(`input[name="${allActiveOptionTitles[index]}"][value="${activeOptionString}"]`);
    if (activeOptionElement) {
      activeOptionElement.checked = true;
    }
  });
};
var getVariantFromId = (productFormElement, variantId) => {
  const allVariants = getAllVariants(productFormElement);
  const correctVariant = allVariants.find((element) => element.id == variantId);
  return correctVariant || null;
};
var getSelectedVariant = (productFormElement) => {
  const variantIdElement = productFormElement.querySelector(".variantId");
  const variantId = variantIdElement ? Number(variantIdElement.value) : null;
  const variant = getVariantFromId(productFormElement, variantId);
  return variant || null;
};
var normalizeSizeValue = (value = "") => value.trim().toLowerCase();
var formatBodyHeightLabel = (bodyHeight = "") => {
  const trimmedBodyHeight = bodyHeight.trim();
  if (!trimmedBodyHeight)
    return "";
  if (/(cm|inch)\b/i.test(trimmedBodyHeight)) {
    return trimmedBodyHeight.replace(/\s*(cm|inch)\b/gi, " $1").replace(/\s+/g, " ").trim();
  }
  if (!/\d/.test(trimmedBodyHeight))
    return trimmedBodyHeight;
  return `${trimmedBodyHeight} cm`;
};
var getSizeChartData = (sizeGuideId) => {
  if (!sizeGuideId)
    return null;
  const allSizeChartDataElements = document.querySelectorAll(".size-chart-data");
  for (const sizeChartDataElement of allSizeChartDataElements) {
    try {
      const sizeCharts = JSON.parse(sizeChartDataElement.innerHTML).sizecharts || [];
      const matchingSizeChart = sizeCharts.find((sizeChart) => sizeChart.id === sizeGuideId);
      if (matchingSizeChart) {
        return matchingSizeChart.data || null;
      }
    } catch (error) {
      continue;
    }
  }
  return null;
};
var setSelectedSizeBodyHeight = (productFormElement, variantObject = null) => {
  var _a, _b, _c, _d;
  const selectedSizeBodyHeightElement = productFormElement.querySelector(".js-selected-size-body-height");
  if (!selectedSizeBodyHeightElement)
    return;
  const sizeGuideId = selectedSizeBodyHeightElement.dataset.sizeGuideId;
  const selectedVariant = variantObject || getSelectedVariant(productFormElement);
  const allOptionTitles = ((_a = selectedVariant == null ? void 0 : selectedVariant.option_titles) == null ? void 0 : _a.split(" || ")) || [];
  const allOptionValues = ((_b = selectedVariant == null ? void 0 : selectedVariant.options) == null ? void 0 : _b.split(" || ")) || [];
  const sizeOptionIndex = allOptionTitles.findIndex((optionTitle) => normalizeSizeValue(optionTitle) === "size");
  const selectedSize = sizeOptionIndex >= 0 ? allOptionValues[sizeOptionIndex] : (_c = productFormElement.querySelector("fieldset.variant--size input:checked")) == null ? void 0 : _c.value;
  const sizeChartData = getSizeChartData(sizeGuideId);
  const matchingSize = (_d = sizeChartData == null ? void 0 : sizeChartData.sizes) == null ? void 0 : _d.find((size) => normalizeSizeValue(size.age) === normalizeSizeValue(selectedSize || ""));
  const bodyHeightLabel = formatBodyHeightLabel((matchingSize == null ? void 0 : matchingSize.body_height) || "");
  if (!bodyHeightLabel) {
    selectedSizeBodyHeightElement.textContent = "";
    selectedSizeBodyHeightElement.hidden = true;
    return;
  }
  selectedSizeBodyHeightElement.textContent = `| ${bodyHeightLabel}`;
  selectedSizeBodyHeightElement.hidden = false;
};
var getValueFromVariantSelector = (variantElement, optionName) => {
  const checkedElement = variantElement.querySelector(
    `input[name="${optionName}"]:checked`
  );
  return (checkedElement == null ? void 0 : checkedElement.value) || null;
};
var getCorrectVariantFromOptions = (productFormElement, variantOptions) => {
  const allVariants = getAllVariants(productFormElement);
  if (allVariants != null) {
    let selectedOptions = "";
    variantOptions.forEach((variantElement) => {
      const optionName = variantElement.dataset.optionName;
      selectedOptions = selectedOptions + " || " + getValueFromVariantSelector(variantElement, optionName);
    });
    selectedOptions = selectedOptions.slice(4);
    return allVariants.find((element) => element.options === selectedOptions) || null;
  }
  return null;
};
var isVariantAvailable = (variant) => variant.available === true || null;
var setVariantImage = debounce((correctVariant) => {
  if (correctVariant) {
    const allVariantImageElements = document.querySelectorAll(".variant-image");
    allVariantImageElements.forEach((variantImageElement) => {
      if (variantImageElement.dataset.variantOptions == correctVariant.options) {
        variantImageElement.classList.remove("js-hidden");
        const event = new CustomEvent("request-to-slide", {
          detail: {
            activeSlide: 0,
            targetSliderClass: "thumbs-parent"
          }
        });
        document.dispatchEvent(event);
      } else {
        variantImageElement.classList.add("js-hidden");
      }
    });
  }
}, 100);
var setVariantId = (productFormElement, variantId) => {
  const variantIdElement = productFormElement.querySelector('product-form input[name="productVariant"]');
  variantIdElement.value = variantId;
};
var setPrice = (productFormElement, variantObject) => {
  const priceHolderElement = productFormElement.querySelector(".price-holder");
  const price = formatMoney(variantObject.price, window.product.money_format).replace(
    ",00",
    ""
  );
  if (variantObject.compare_at_price) {
    const compareAtPrice = formatMoney(variantObject.compare_at_price, window.product.money_format).replace(
      ",00",
      ""
    );
    priceHolderElement.innerHTML = `
      <span class="price price--underlined">${compareAtPrice}</span>
      <span class="price price--has-compare-price">${price}</span>
    `;
  } else {
    priceHolderElement.innerHTML = `
      <span class="price">${price}</span>
    `;
  }
};
var setStockStatus = (productFormElement, variantObject) => {
  var _a, _b, _c, _d, _e, _f;
  const stockStatusContainer = document.querySelector(".stock-status-container");
  if (!stockStatusContainer)
    return;
  const inventory = variantObject.inventory_quantity;
  const isAvailable = variantObject.available;
  const lowStock = parseInt(stockStatusContainer.dataset.lowStock);
  let stockHTML = "";
  if (inventory <= 0 || isAvailable === false) {
    stockHTML = `<span class='stock-status sold-out'><span class='stock-status__dot stock-status__dot--red'></span>${((_b = (_a = window.product) == null ? void 0 : _a.translations) == null ? void 0 : _b.sold_out) || "Sold Out"}</span>`;
  } else if (inventory <= lowStock) {
    stockHTML = `<span class='stock-status low-stock'><span class='stock-status__dot stock-status__dot--orange'></span>${((_d = (_c = window.product) == null ? void 0 : _c.translations) == null ? void 0 : _d.low_in_stock) || "Low in Stock"}</span>`;
  } else {
    stockHTML = `<span class='stock-status in-stock'><span class='stock-status__dot stock-status__dot--green'></span>${((_f = (_e = window.product) == null ? void 0 : _e.translations) == null ? void 0 : _f.in_stock) || "In Stock"}</span>`;
  }
  const existingStockStatus = stockStatusContainer.querySelector(".stock-status");
  const findInStoreButton = stockStatusContainer.querySelector(".button--find-in-store");
  if (existingStockStatus) {
    existingStockStatus.outerHTML = stockHTML;
  } else {
    if (findInStoreButton) {
      findInStoreButton.insertAdjacentHTML("beforebegin", stockHTML);
    } else {
      stockStatusContainer.innerHTML = stockHTML;
    }
  }
};

// src/utils/get-sections.js
var getCartSectionsToRender = () => {
  var _a, _b, _c, _d, _e, _f;
  return [
    {
      id: "cart-items",
      section: (_a = document.getElementById("cart-items")) == null ? void 0 : _a.dataset.id,
      selector: "#cart-items"
    },
    {
      id: "cart-promo-meter",
      section: (_b = document.getElementById("cart-items")) == null ? void 0 : _b.dataset.id,
      selector: "#cart-promo-meter"
    },
    {
      id: "cart-buy-get-text",
      section: (_c = document.getElementById("cart-items")) == null ? void 0 : _c.dataset.id,
      selector: "#cart-buy-get-text"
    },
    {
      id: "cart-gift-wrapping",
      section: (_d = document.getElementById("cart-items")) == null ? void 0 : _d.dataset.id,
      selector: "#cart-gift-wrapping"
    },
    {
      id: "cart-cards",
      section: (_e = document.getElementById("cart-items")) == null ? void 0 : _e.dataset.id,
      selector: "#cart-cards"
    },
    {
      id: "cart-item-counter",
      section: "cart-item-counter",
      selector: "#cart-item-counter"
    },
    {
      id: "cart-summary",
      section: (_f = document.querySelector(".cart-drawer__summary")) == null ? void 0 : _f.dataset.sectionId,
      selector: "#cart-summary"
    },
    {
      id: "related-products-cart",
      section: "related-products-cart",
      selector: "#related-products-cart"
    }
  ];
};

// src/utils/dissect-form.js
var dissectForm = (formData) => {
  if (formData.productVariant) {
    const defaultQuantity = 1;
    const variantID = formData.productVariant;
    const quantity = formData.quantity ? formData.quantity : defaultQuantity;
    const data = {
      id: variantID,
      quantity,
      properties: {},
      sections: getCartSectionsToRender().map((section) => section.section)
    };
    return JSON.stringify(data);
  }
  return null;
};

// src/utils/section-injection.js
var getSectionFromHTML = (html, selector) => {
  if (html) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
};

// src/utils/cart.js
var handleChangeCart = (responseData) => {
  getCartSectionsToRender().forEach((section) => {
    const elementToReplace = document.querySelectorAll(section.selector) || document.getElementById(section.id).querySelector(section.selector);
    if (elementToReplace !== null) {
      elementToReplace.forEach((element) => {
        element.innerHTML = getSectionFromHTML(
          responseData.sections[section.section],
          section.selector
        );
      });
    }
  });
  const cardElement = document.querySelector(".cart-drawer__cart-cards");
  if (cardElement) {
    const allOpenModalButtonElements = cardElement.querySelectorAll(".js-handle-modal");
    const baseModal = new surf_modal_default();
    allOpenModalButtonElements.forEach((openModalButtonElement) => {
      const ariaControls = openModalButtonElement ? openModalButtonElement.getAttribute("aria-controls") : null;
      openModalButtonElement.addEventListener("click", () => {
        baseModal.handleModalState(ariaControls, openModalButtonElement);
      }, true, { passive: true });
    });
  }
};

// src/services/shopify-services.js
var import_axios = __toESM(require_axios2(), 1);
var shopifyServices = class {
  /**
   * Update cart with a axios call.
   *
   * @param method {string}
   * @param url {string}
   * @param selectedElement {HTMLElement}
   * @param body {string}
   */
  async updateCart(method, url, selectedElement, body) {
    try {
      if (selectedElement) {
        selectedElement.classList.add("js-is-loading");
      }
      await (0, import_axios.default)({
        method,
        url,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        console.log(responseData);
        handleChangeCart(responseData);
        selectedElement.classList.remove("js-is-loading");
      });
    } catch (error) {
      if (error.response ? error.response.status === 422 : false) {
        if (selectedElement) {
          selectedElement.classList.remove("js-is-loading");
          selectedElement.classList.add("js-all-in-cart");
        }
      } else {
        if (selectedElement) {
          selectedElement.classList.remove("js-is-loading");
          selectedElement.classList.add("js-change-failed");
        }
      }
    }
  }
};
var shopify_services_default = shopifyServices;

// src/services/shopify-cart.js
var shopifyCart = class extends shopify_services_default {
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param formData {object}
   * @param selectedElement {HTMLElement}
   *
   * @returns cart object
   */
  async add(formData, selectedElement) {
    const method = "POST";
    const url = "/cart/add.js";
    const body = JSON.stringify({
      ...JSON.parse(dissectForm(formData))
    });
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Remove item from the cart.
   *
   * @param line {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async remove(line, selectedElement) {
    const method = "POST";
    const url = "/cart/change.js";
    const body = JSON.stringify({
      line,
      quantity: 0,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Remove item from the cart.
   *
   * @param line {number}
   * @param quantity {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async updateQuantity(line, quantity, selectedElement) {
    const method = "POST";
    const url = "/cart/change.js";
    const body = JSON.stringify({
      line,
      quantity,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    console.log("updateQuantity", line);
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Quick buy option.
   *
   * @param variantId {number}
   * @param quantity {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async quickBuy(variantId, quantity, selectedElement, properties) {
    const method = "POST";
    const url = "/cart/add.js";
    const body = {
      id: variantId,
      quantity,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    if (properties) {
      body.properties = properties;
    }
    await this.updateCart(method, url, selectedElement, JSON.stringify(body));
  }
};
var shopify_cart_default = new shopifyCart();

// src/extenders/product-form.js
var ProductForm = class extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.addToCartButton = null;
    this.cleanupFormInputs = () => {
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDomContentLoaded = this.handleDomContentLoaded.bind(this);
  }
  connectedCallback() {
    this.form = this.querySelector("form");
    this.addToCartButton = this.querySelector("#addToBagButton");
    if (!this.form)
      return;
    setFirstAvialableVariantActive(this);
    handleVariantAfterInputChange(this);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.handleDomContentLoaded, { once: true });
    } else {
      this.handleDomContentLoaded();
    }
    this.cleanupFormInputs = handleFormInputs(this, this.form);
    this.form.addEventListener("submit", this.handleSubmit);
  }
  disconnectedCallback() {
    document.removeEventListener("DOMContentLoaded", this.handleDomContentLoaded);
    if (this.form) {
      this.form.removeEventListener("submit", this.handleSubmit);
    }
    this.cleanupFormInputs();
    this.cleanupFormInputs = () => {
    };
  }
  handleDomContentLoaded() {
    setSelectedSizeBodyHeight(this);
  }
  /**
   * Attach listener to the form submit buttons.
   *
   * @param event {object}
   *
   * @returns {boolean}
   */
  async handleAddToCart(event) {
    const formData = Object.fromEntries(new FormData(event.target).entries());
    if (formData.productVariant && this.form.checkValidity()) {
      await shopify_cart_default.add(formData, this.addToCartButton);
      const cartDrawer = new surf_modal_default();
      const cartDrawerOpenerElement = document.querySelector('.js-handle-modal[data-target-id="cart-drawer"]');
      cartDrawer.handleModalState("cart-drawer", cartDrawerOpenerElement);
    }
  }
  handleSubmit(event) {
    event.preventDefault();
    this.handleAddToCart(event);
  }
};
if (customElements.get("product-form") === void 0) {
  customElements.define("product-form", ProductForm);
}
